// BtnDanhGia.js
import React, { useState } from "react";
import { ModalDanhGia } from "./ModalDanhGia";

export const BtnDanhGia = ({ item, onReload, disabled }) => {
    const [show, setShow] = useState(false);
    return (
        <>
            <a type="button" className="popover-basic"  disabled={disabled} onClick={() => setShow(true)} title="Đánh giá">
                <img src="/app-assets/images/icon-danh-gia.png" alt="Đánh giá" />
            </a>
            {show && <ModalDanhGia item={item} show={show} onHide={() => setShow(false)} onSaved={() => {setShow(false); onReload();}} />}
        </>
    );
};